import React from "react";
import { FormControl } from "react-bootstrap";

const ReminderRecipientsFilter = ({ filters, onChange }) => {
    return (
        <>
            <th>
                <FormControl
                    type="text"
                    name="email"
                    defaultValue={filters?.email || ''}
                    onChange={(e) => onChange('email', e.target.value)}
                />
            </th>
            <th>
                <FormControl
                    type="text"
                    name="sentAt"
                    defaultValue={filters?.sentAt || ''}
                    onChange={(e) => onChange('sentAt', e.target.value)}
                />
            </th>
            <th>
                <FormControl
                    type="text"
                    name="status"
                    defaultValue={filters?.status || ''}
                    onChange={(e) => onChange('status', e.target.value)}
                />
            </th>
            <th>
                <FormControl
                    type="text"
                    name="opened"
                    defaultValue={filters?.opened || ''}
                    onChange={(e) => onChange('opened', e.target.value)}
                />
            </th>
            <th style={{width: '40px'}}></th>
        </>
    );
};

export default ReminderRecipientsFilter;
